import { InputLabel, MenuItem, Select } from "@mui/material";
import { FieldInputProps } from "react-final-form";
import { FormattedMessage as T } from "react-intl";

const SelectEnvironment = (props: FieldInputProps<string, HTMLElement>) => {
  return (
    <>
      <InputLabel>
        <T id="environmentLabel" />
      </InputLabel>
      <Select {...props}>
        <MenuItem value="local">local</MenuItem>
        <MenuItem value="dev">dev</MenuItem>
        <MenuItem value="qa">qa</MenuItem>
        <MenuItem value="prod">prod</MenuItem>
      </Select>
    </>
  );
};

export default SelectEnvironment;
